// src/data/initialDetails.js

const initialDetails = [
  {
    id: 1,
    imgPath: "/assets/img/1.png",
    name: "Dog",
    type:'Herbivorous',
    address: "New Delhi, India",
  },
  {
    id: 2,
    imgPath: "/assets/img/2.png",
    name: "Cat",
    type: "Herbivorous",
    address: "Tbilisi, India",
  },
  {
    id: 3,
    imgPath: "/assets/img/3.png",
    name: "Sherlock Watson",
    type: "Herbivorous",
    address: "Baker Street, India",
  },
  {
    id: 4,
    imgPath: "/assets/img/4.png",
    name: "John Holmes",
    type: "Herbivorous",
    address: "Baker Street, India",
  },
  {
    id: 5,
    imgPath: "/assets/img/5.png",
    name: "Mycroft Lestrade",
    type: "Herbivorous",
    address: "London, India",
  },
];

export default initialDetails;